module.exports = __webpack_public_path__ + "static/media/banjo.063e2ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LessonsPage/assets/banjo.png
// module id = 519
// module chunks = 0